export default function MapAPI() {
  return (
    'AIzaSyBHjFAoFrHNd0x-mYqRrI-ZkpT8boKLCTw'
  );
}



// WEBPACK FOOTER //
// ./src/google.js